"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parl = exports.parw = exports.ParameterSet = void 0;
exports.parb = parb;
exports.pars = pars;
exports.parr = parr;
exports.pary = pary;
exports.parn = parn;
exports.pushParameter = pushParameter;
exports.pushParameterBinary = pushParameterBinary;
exports.pushParameterString = pushParameterString;
exports.pushParameterStringBinary = pushParameterStringBinary;
const ediabasx_core_1 = require("@emdzej/ediabasx-core");
const register_values_1 = require("./register-values");
class ParameterSet {
    parameters = new Map();
    binaryPayload = new Uint8Array();
    set(index, parameter) {
        this.parameters.set(index, parameter);
        if (parameter.kind === "binary") {
            this.binaryPayload = new Uint8Array(parameter.value);
        }
    }
    get(index) {
        return this.parameters.get(index);
    }
    size() {
        return this.parameters.size;
    }
    getBinaryPayload() {
        return new Uint8Array(this.binaryPayload);
    }
}
exports.ParameterSet = ParameterSet;
function parseEdiabasInt(value) {
    let parsedValue = 0;
    let valid = false;
    const trimmed = value.trimEnd();
    if (trimmed.length === 0) {
        return { value: parsedValue, valid };
    }
    const lower = trimmed.toLowerCase();
    try {
        if (lower.startsWith("0x")) {
            if (lower.length > 2) {
                const firstChar = lower[2];
                if ((firstChar >= "0" && firstChar <= "9") || (firstChar >= "a" && firstChar <= "f")) {
                    parsedValue = parseInt(trimmed.slice(2), 16);
                    valid = true;
                }
            }
        }
        else if (lower.startsWith("0y")) {
            parsedValue = parseInt(trimmed.slice(2), 2);
            valid = true;
        }
        else {
            if (lower !== "-" && lower !== "--") {
                if (!(lower[0] >= "a" && lower[0] <= "z")) {
                    let numberConv = trimmed.trimStart();
                    const index = numberConv.search(/[.,]/);
                    if (index >= 0) {
                        numberConv = numberConv.slice(0, index);
                    }
                    parsedValue = parseInt(numberConv, 10);
                    valid = true;
                }
            }
        }
    }
    catch {
        parsedValue = 0;
    }
    if (Number.isNaN(parsedValue)) {
        parsedValue = 0;
        valid = false;
    }
    return { value: parsedValue, valid };
}
function parseEdiabasFloat(value) {
    const normalized = value.replace(/,/g, ".");
    const parsed = parseFloat(normalized);
    if (Number.isNaN(parsed)) {
        return { value: 0, valid: false };
    }
    return { value: parsed, valid: true };
}
function resolveIntParameter(parameter) {
    if (!parameter) {
        return 0;
    }
    switch (parameter.kind) {
        case "int":
            return parameter.value | 0;
        case "float":
            return Math.trunc(parameter.value);
        case "string":
            return parseEdiabasInt(parameter.value).value | 0;
        case "binary":
            return parameter.value.length | 0;
        case "null":
            return 0;
    }
}
function resolveFloatParameter(parameter) {
    if (!parameter) {
        return 0;
    }
    switch (parameter.kind) {
        case "float":
            return parameter.value;
        case "int":
            return parameter.value;
        case "string":
            return parseEdiabasFloat(parameter.value).value;
        case "binary":
            return parameter.value.length;
        case "null":
            return 0;
    }
}
function resolveStringParameter(parameter) {
    if (!parameter) {
        return "";
    }
    switch (parameter.kind) {
        case "string":
            return parameter.value;
        case "int":
            return parameter.value.toString(10);
        case "float":
            return parameter.value.toString(10);
        case "binary":
            return (0, ediabasx_core_1.cp1252ToUtf8)(parameter.value);
        case "null":
            return "";
    }
}
/**
 * BEST2 parameter retrieval mirrors C# OpParl/OpPars/OpParr: GetActiveArgStrings()
 * treats every job parameter as a string. Z=true iff the parameter slot is missing
 * or holds an empty string — independent of the parsed numeric value.
 */
function isParameterEmpty(parameter) {
    if (!parameter)
        return true;
    switch (parameter.kind) {
        case "null":
            return true;
        case "string":
            return parameter.value.length === 0;
        case "binary":
            return parameter.value.length === 0;
        case "int":
        case "float":
            return false;
    }
}
function parb(registers, flags, parameters, destination, index) {
    const position = index - 1;
    const parameter = position >= 0 ? parameters.get(position) : undefined;
    let value = 0;
    flags.c = false;
    flags.s = false;
    flags.v = false;
    flags.z = isParameterEmpty(parameter);
    if (parameter && !flags.z) {
        if (parameter.kind === "string") {
            value = parseEdiabasInt(parameter.value).value;
        }
        else {
            value = resolveIntParameter(parameter);
        }
    }
    (0, register_values_1.setIntValue)(registers, destination, value);
}
exports.parw = parb;
exports.parl = parb;
function pars(registers, flags, parameters, destination, index) {
    const position = index - 1;
    const parameter = position >= 0 ? parameters.get(position) : undefined;
    flags.z = isParameterEmpty(parameter);
    const value = flags.z ? "" : resolveStringParameter(parameter);
    (0, register_values_1.setStringValue)(registers, destination, value);
}
function parr(registers, flags, parameters, destination, index) {
    const position = index - 1;
    const parameter = position >= 0 ? parameters.get(position) : undefined;
    let value = 0;
    flags.c = false;
    flags.s = false;
    flags.v = false;
    flags.z = isParameterEmpty(parameter);
    if (parameter && !flags.z) {
        if (parameter.kind === "string") {
            value = parseEdiabasFloat(parameter.value).value;
        }
        else {
            value = resolveFloatParameter(parameter);
        }
    }
    (0, register_values_1.setFloatValue)(registers, destination, value);
}
function pary(registers, flags, parameters, destination) {
    // Mirrors C# `OpPary` (EdOperations.cs:1861): writes the raw binary
    // payload via `SetArrayData(byte[])` — no NUL terminator, no codec
    // round-trip. Going through `setStringValue` (string path) would
    // append a `\0` when the last byte isn't already `0x00`, growing the
    // destination S register by one and breaking any SGBD that
    // length-checks the payload via `slen` (e.g. BMW NCS `C_S_SCHREIBEN`
    // tripping `ERROR_BIN_BUFFER`).
    const payload = parameters.getBinaryPayload();
    flags.z = payload.length === 0;
    (0, register_values_1.setBinaryValue)(registers, destination, payload);
}
function parn(registers, flags, parameters, destination) {
    (0, register_values_1.setIntValue)(registers, destination, parameters.size());
    const value = (0, register_values_1.getIntValue)(registers, destination);
    const length = destination.kind === "I" ? 2 : destination.kind === "L" ? 4 : 1;
    const mask = length === 4 ? 0xffffffff : (1 << (length * 8)) - 1;
    const signMask = 1 << (length * 8 - 1);
    const masked = value & mask;
    flags.z = masked === 0;
    flags.s = (masked & signMask) !== 0;
    flags.v = false;
}
function pushParameter(parameters, index, source, registers) {
    if (source.kind === "S") {
        parameters.set(index, { kind: "string", value: (0, register_values_1.getStringValue)(registers, source) });
        return;
    }
    if (source.kind === "F") {
        parameters.set(index, { kind: "float", value: (0, register_values_1.getFloatValue)(registers, source) });
        return;
    }
    parameters.set(index, { kind: "int", value: (0, register_values_1.getIntValue)(registers, source) });
}
function pushParameterBinary(parameters, index, value) {
    parameters.set(index, { kind: "binary", value: new Uint8Array(value) });
}
function pushParameterString(parameters, index, value) {
    parameters.set(index, { kind: "string", value });
}
function pushParameterStringBinary(parameters, index, value) {
    parameters.set(index, { kind: "binary", value: (0, ediabasx_core_1.utf8ToCp1252)(value) });
}
//# sourceMappingURL=parameters.js.map